export default __webpack_public_path__ + "static/10-247d24d042466d84034686664478f1fb.png";